export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.2-0856.25",
  commitId: "3d51ee689afcff96137edcf6f08b2f5acb522545",
  commitTime: "2026-04-02T08:56:25.000Z",
});
